import { PortableText } from '@portabletext/react'
import styles from './Testimonial.module.scss'
import { useState } from 'react'
import classNames from 'classnames'

export default function Testimonial({
  pullQuote,
  excerpt,
  isCapped,
  body,
  name,
  date,
}) {
  const [expanded, setExpanded] = useState(!isCapped)

  return (
    <div className={styles.testimonial}>
      <div className={styles.testimonial__pullQuote}>{pullQuote}</div>
      <blockquote
        className={classNames(styles.testimonial__body, {
          [styles['testimonial__body--excerpt']]: isCapped && !expanded,
        })}
      >
        <PortableText value={isCapped && !expanded ? excerpt : body} />
      </blockquote>
      {!expanded && (
        <button
          className={styles.testimonial__readMore}
          onClick={() => {
            setExpanded(true)
          }}
        >
          Read more…
        </button>
      )}
      <figcaption className={styles.testimonial__name}>{name}</figcaption>
    </div>
  )
}
